import React from "react";
import { useIntl, defineMessages } from "react-intl";
import GroupForm, {
    GroupFormProps,
    GroupFormValues,
} from "../../../../../../components/GroupForm/GroupForm";
import { useDashboardRouter } from "../../../routing";

const DashboardGroupForm = (
    props: Omit<GroupFormProps, "defaultValues" | "messages"> & {
        defaultValues?: GroupFormValues;
    }
) => {
    const intl = useIntl();
    const { classroomList: classroomListUrl } = useDashboardRouter();

    return (
        <GroupForm
            {...props}
            defaultValues={
                props.defaultValues ?? {
                    name: intl.formatMessage(messages.newGroup),
                    students: [],
                }
            }
            messages={groupMessages}
            goBackUrl={classroomListUrl}
        />
    );
};

export default DashboardGroupForm;

const messages = defineMessages({
    classroomListDescription: {
        id: "group-form-classroomListDescription",
        defaultMessage:
            "Select the students you want to add to your new group.",
    },
    newGroup: {
        id: "group-form-newGroup",
        defaultMessage: "New group",
    },
    noAddedStudents: {
        id: "group-form-noAddedStudents",
        defaultMessage: "No students yet",
    },
    groupName: {
        id: "group-form-groupName",
        defaultMessage: "Group name",
    },
    groupNameInstruction: {
        id: "group-form-groupNameInstruction",
        defaultMessage: "Enter the group name",
    },
    cancel: {
        id: "group-form-cancel",
        defaultMessage: "Cancel",
    },
    submit: {
        id: "group-form-submit",
        defaultMessage: "Save",
    },
    groupCreationGoBackToClassroomList: {
        id: "create-group-GoBackToClassroomList",
        defaultMessage: "Go back to the classroom list",
    },
    groupCreationRemoveStudent: {
        id: "create-group-removeStudent",
        defaultMessage: "Remove student from the list",
    },
});

const groupMessages = {
    description: messages.classroomListDescription,
    submit: messages.submit,
    backTo: messages.groupCreationGoBackToClassroomList,
    groupName: messages.groupName,
    groupNameInstruction: messages.groupNameInstruction,
};
